// extracted by mini-css-extract-plugin
export var cost = "style-module--cost--a4874";
export var cost__blocks = "style-module--cost__blocks--16458";
export var cost__infoBlock = "style-module--cost__info-block--2b762";
export var cost__infoItem = "style-module--cost__info-item--6c0a2";
export var cost__infoText = "style-module--cost__info-text--d0051";
export var cost__prices = "style-module--cost__prices--3e1ad";
export var cost__pricesBlock = "style-module--cost__prices-block--e5df8";
export var cost__pricesButton = "style-module--cost__prices-button--38c99";
export var cost__pricesButtonKrp = "style-module--cost__prices-button-krp--bcd93";
export var cost__pricesBuy = "style-module--cost__prices-buy--64b84";
export var cost__pricesHeader = "style-module--cost__prices-header--325f6";
export var cost__pricesHeaderKrp = "style-module--cost__prices-header-krp--b6de0";
export var cost__pricesItem = "style-module--cost__prices-item--99cdc";
export var cost__pricesList = "style-module--cost__prices-list--e41b2";
export var cost__pricesPrice = "style-module--cost__prices-price--2b9e2";
export var cost__pricesPriceKrp = "style-module--cost__prices-price-krp--3f7c2";
export var cost__pricesPriceOld = "style-module--cost__prices-price-old--5624a";
export var cost__pricesText = "style-module--cost__prices-text--f2d13";
export var cost__undertext = "style-module--cost__undertext--0c8b0";
export var month = "style-module--month--8c8d9";